import { render, staticRenderFns } from "./goodGroup.vue?vue&type=template&id=c6cc5d44&scoped=true"
import script from "./goodGroup.vue?vue&type=script&lang=js"
export * from "./goodGroup.vue?vue&type=script&lang=js"
import style0 from "./goodGroup.vue?vue&type=style&index=0&id=c6cc5d44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cc5d44",
  null
  
)

export default component.exports